import MethodBuilder from "../../method-builder";
import {
  TFinancialReportAggregatedItem,
  TFinancialReportItem,
  TPaging,
} from "../../types";

export class FinancialReportAPI {
  static filter = new MethodBuilder<
    ExclusifyUnion<
      (
        | { clientId: number }
        | { agentId: number }
        | { hallId: number }
        | { playerId: number }
        | { kioskId: number }
      ) & {
        currency?: string;
        dateTimeRange?: {
          // ISO 8601
          from: string;
          // ISO 8601
          to: string;
        };
        paging: TPaging;
      }
    >,
    {
      data: TFinancialReportItem[];
      total: number;
    }
  >()
    .withName("FinancesReport.filter")
    .build();

  static aggregate = new MethodBuilder<
    ExclusifyUnion<
      (
        | { clientId: number }
        | { agentId: number }
        | { hallId: number }
        | { playerId: number }
        | { kioskId: number }
      ) & {
        groupBy: "currency" | "player" | "kiosk" | "user" | "hall";
        currency?: string;
        dateTimeRange?: {
          // ISO 8601
          from: string;
          // ISO 8601
          to: string;
        };
        paging: TPaging;
      }
    >,
    {
      data: TFinancialReportAggregatedItem[];
      total: number;
    }
  >()
    .withName("FinancesReport.aggregate")
    .build();
}
